import { TabsType } from 'components/Tabs/Tabs';
import { Translation } from 'hooks/useTranslation/useTranslation';

export const createEventsTabs = (translation: Translation): TabsType[] => [
  {
    text: translation.access_events,
    location: '/events/access-events'
  }
];
